import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import ThemeContext from "components/app/Context";
import Typography from "components/common/Typography";
import { useContext } from "react";
import { tokens } from "styles/Tokens";

interface Props {
  data: any;
  onSelect: (...args: any) => void;
  selected: string | null;
}

const InncodeItem = (props: Props) => {
  const { data, selected, onSelect } = props;
  const { isMobileScreen } = useContext(ThemeContext);
  const activeStyle =
    selected && selected === data?.innCode && !isMobileScreen
      ? { backgroundColor: tokens.Background.General.Tertiary, borderRadius: "8px" }
      : {};

  return (
    <Stack direction="row" alignItems="center" onClick={() => onSelect(data)}>
      <Box sx={{ mr: isMobileScreen ? 0 : "24px", padding: "12px", cursor: "pointer", flex: 1, ...activeStyle }}>
        {data?.name && (
          <Typography showBold variant="body1" color={tokens.Text.General.PrimaryHeadline} sx={{ mb: "8px" }}>
            {data?.name}
          </Typography>
        )}
        <Stack direction="row" alignItems="center">
          <Typography variant="body2" color={tokens.Text.General.Tertiary}>
            {data?.innCode}
          </Typography>
        </Stack>
      </Box>
      {isMobileScreen && <NavigateNextIcon sx={{ fontSize: "24px", ml: "8px" }} />}
    </Stack>
  );
};

export default InncodeItem;
